export var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};
